import React, { useContext, useState, useEffect } from "react";
import {
  Input,
  InputLabel,
  FormControl,
  InputAdornment,
  Grid,
  Typography,
  Select,
  MenuItem,
  Button,
} from "@material-ui/core";
import UploadIcon from "@material-ui/icons/Publish";
import { useTranslation } from "react-i18next";

import { DeploymentContext, FleetContext } from "../../context";
import { SectionGridContainer, SectionGridLayout } from "../../components/Layout";
import { LoadingOverlay } from "../../components/Navigation/LoadingOverlay";
import { FilledTextField } from "../../components/FormElements";
import { validateEmail } from "../../services/misc.service";

const DEFAULT_CUSTOMER = "Link";

const Manifest = () => {
  const { uploadManifest, manifestResponse } = useContext(DeploymentContext);
  const { fleets, fetchFleets } = useContext(FleetContext);
  const { t } = useTranslation();
  const [emailDirty, setEmailDirty] = useState(false);
  const [email, setEmail] = useState("");
  const [fleetName, setFleetName] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [loadingFleets, setLoadingFleets] = useState(false);
  const cluster = window.REACT_APP_CLUSTER_NAME;

  // Fetch fleets once on page load if they are not there
  useEffect(() => {
    if (!fleets || !fleets.size) {
      setLoadingFleets(true);
      fetchFleets();
    }
  }, []);

  // Select first fleet in dropdown
  useEffect(() => {
    if (fleets && fleets.size) {
      setFleetName(Array.from(fleets.values())[0].name);
    }
    setLoadingFleets(false);
  }, [fleets]);

  const submit = async () => {
    setLoadingSubmit(true);
    try {
      if (!validateEmail(email)) throw new Error("Invalid Email");
      await uploadManifest(selectedFile, DEFAULT_CUSTOMER, fleetName, [email], cluster); // provide emails as an array
    } catch (e) {
      console.error(e);
      setLoadingSubmit(false);
    }
    setLoadingSubmit(false);
  };

  if (loadingSubmit || loadingFleets) {
    return <LoadingOverlay />;
  }
  return (
    <SectionGridLayout>
      <SectionGridContainer spaceContents>
        <Grid item xs={12}>
          <Typography variant="h5">{t("Manifest.Title")}</Typography>
          <a
            className="spBlue"
            href="https://superpedestrian.atlassian.net/wiki/spaces/CS/pages/1522630921/Manifest+Upload+Page+-+Instructions+for+Use"
          >
            Instructions For Use
          </a>
        </Grid>
        <Grid item xs={12}>
          <FormControl>
            <InputLabel>Manifest file</InputLabel>
            <Input
              type="file"
              id="uploadJSON"
              accept=".json"
              onChange={(event) => setSelectedFile(event.target.files[0])}
              startAdornment={
                <InputAdornment position="start">
                  <UploadIcon data-testid="upload-icon" />
                </InputAdornment>
              }
            />
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <FormControl>
            <InputLabel>Destination Fleet</InputLabel>
            <Select
              label="Fleet"
              value={fleetName}
              onChange={(event) => setFleetName(event.target.value)}
            >
              {fleets &&
                Array.from(fleets.entries()).map(([fleetId, fleet]) => (
                  <MenuItem key={fleetId} value={fleet.name}>
                    {fleet.name}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <FilledTextField
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            type="email"
            label={t("RegistrationViews.RecipientEmail")}
            error={emailDirty && !validateEmail(email)}
            onBlur={() => setEmailDirty(true)}
          />
        </Grid>
        <Grid item xs={12}>
          <FormControl>
            <Button onClick={submit}>Submit</Button>
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          {manifestResponse && <pre>{JSON.stringify(manifestResponse, undefined, 4)}</pre>}
        </Grid>
      </SectionGridContainer>
    </SectionGridLayout>
  );
};

export default Manifest;
